import getConfig from 'next/config';

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig();

export const APP_ENV: any = publicRuntimeConfig.NEXT_PUBLIC_APP_ENV || 'production';
export const API_URI: any = publicRuntimeConfig.NEXT_PUBLIC_API_URL || process.env.API_URL;
export const APP_URL: any = publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
export const APP_IMG: any = publicRuntimeConfig.NEXT_PUBLIC_IMG;
export const NEXT_PUBLIC_IS_COMMEMORATE = publicRuntimeConfig.NEXT_PUBLIC_IS_COMMEMORATE || process.env.NEXT_PUBLIC_IS_COMMEMORATE;
export const isProd: boolean = APP_ENV.toLowerCase() === 'production';
export const IS_NO_ROBOT_INDEX: boolean = !isProd;

/* ----------------------------- PUBLIC_RUNTIME ------------------------------ */

// GTM
export const GTM_ID: any = publicRuntimeConfig.NEXT_PUBLIC_GTM_ID || process.env.NEXT_PUBLIC_GTM_ID;
// GSERVICE
export const GSERVICE_URL: any = publicRuntimeConfig.NEXT_PUBLIC_GSERVICE_URL || 'https://gservice.thepeople.co';
// RECAPTCHA
export const RECAPTCHA_SITE_KEY: any = publicRuntimeConfig.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
// export const RECAPTCHA_SITE_KEY: any = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || publicRuntimeConfig.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '6LcdTJggAAAAAC33nvXmCPKBuYQ4iuuzjlsQaWed';
export const COUNTVIEW_SHOW_COUNT: any = process.env.NEXT_SERVER_COUNTVIEW_SHOW_COUNT || serverRuntimeConfig.NEXT_SERVER_COUNTVIEW_SHOW_COUNT || 0;

export const TRUE_HITS_URL = publicRuntimeConfig.NEXT_PUBLIC_TRUE_HITS_URL;
/* ----------------------------- SERVER_RUNTIME ------------------------------ */
// RECAPTCHA
export const RECAPTCHA_SECRET_KEY: any = serverRuntimeConfig.NEXT_SERVER_RECAPTCHA_SECRET_KEY;
// export const RECAPTCHA_SECRET_KEY: any = process.env.NEXT_SERVER_RECAPTCHA_SECRET_KEY || serverRuntimeConfig.NEXT_SERVER_RECAPTCHA_SECRET_KEY || '6LcdTJggAAAAAJY3bGfWgpunApstnbM9CaDsJn_D';
export const CONTENT_DEFAULT: any = process.env.NEXT_SERVER_DEFAULT_ID || serverRuntimeConfig.NEXT_SERVER_DEFAULT_ID || 0;

// REDIS
export const REDIS_HOST = serverRuntimeConfig.REDIS_HOST;
export const REDIS_PASSWORD = serverRuntimeConfig.REDIS_PASSWORD;
export const REDIS_TTL = serverRuntimeConfig.REDIS_TTL || 86400;

// SHOW_COMMEMORATE
export const SHOW_COMMEMORATE = publicRuntimeConfig.SHOW_COMMEMORATE || process.env.SHOW_COMMEMORATE;
export const SHOW_RIBBON = publicRuntimeConfig.SHOW_RIBBON || process.env.SHOW_RIBBON;

export const CLOSE_ADS_HRAD_ENV = publicRuntimeConfig.CLOSE_ADS_HRAD_ENV;
// speech
export const NEXT_PUBLIC_URL_SOUND = publicRuntimeConfig.NEXT_PUBLIC_URL_SOUND;
export const NEXT_PUBLIC_URL_PATH_SOUND = publicRuntimeConfig.NEXT_PUBLIC_URL_PATH_SOUND;
export const NEXT_PUBLIC_WEB_NAME_SOUND = publicRuntimeConfig.NEXT_PUBLIC_WEB_NAME_SOUND;
export const NEXT_PUBLIC_ID_MOCK_SOUND = publicRuntimeConfig.NEXT_PUBLIC_ID_MOCK_SOUND;
export const NEXT_PUBLIC_PLACEHOLDER_TITLE_SUOND = publicRuntimeConfig.NEXT_PUBLIC_PLACEHOLDER_TITLE_SUOND;
export const NEXT_PUBLIC_PLACEHOLDER_TIME_OUT = publicRuntimeConfig.NEXT_PUBLIC_PLACEHOLDER_TIME_OUT;

export const AUTH0_BASE_URL = serverRuntimeConfig.AUTH0_BASE_URL;
export const AUTH0_ISSUER_BASE_URL = serverRuntimeConfig.AUTH0_ISSUER_BASE_URL;
export const AUTH0_CLIENT_ID = serverRuntimeConfig.AUTH0_CLIENT_ID;
export const AUTH0_CLIENT_SECRET = serverRuntimeConfig.AUTH0_CLIENT_SECRET;
export const NEXT_PUBLIC_LOGIN_COOKIE_DATE = publicRuntimeConfig.NEXT_PUBLIC_LOGIN_COOKIE_DATE || 1;
export const NEXT_PUBLIC_SPEED_KEYPOINT = publicRuntimeConfig.NEXT_PUBLIC_SPEED_KEYPOINT;

export const NEXT_PUBLIC_YOUTUBE_CHANNEL_ID: any = publicRuntimeConfig.NEXT_PUBLIC_YOUTUBE_CHANNEL_ID || 'UUsriQe5u_yPyCOF84K9_W6w';
